import { getValue } from '@chilipiper/config'

export const getExtensionIdResource = () => getValue('REACT_APP_EXTENSION_ID_RESOURCE')

/**
 * The logo.dev publishable key (`pk_…`) for company logos. Publishable by design — it ships in the
 * bundle like the Rollout and Chameleon keys and can be domain-restricted in the logo.dev
 * dashboard. Empty or absent disables logos everywhere: the URL helper answers undefined and every
 * surface falls back to what it rendered before logos existed.
 */
export const getLogoDevToken = () => getValue('REACT_APP_LOGO_DEV_TOKEN')
